import script from "./ModificaRilevazione.vue?vue&type=script&setup=true&lang=js"
export * from "./ModificaRilevazione.vue?vue&type=script&setup=true&lang=js"

import "./ModificaRilevazione.vue?vue&type=style&index=0&id=a4b22768&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4b22768"]])

export default __exports__